export const languages = {
  en: "English",
  fi: "Suomi",
};

export const defaultLang = "en";

export const translations = {
  fi: {
    "home.title": "Maksimoi liiketoimintasi potentiaali jo tänään",
    "home.description":
      "Tervetuloa Geimit.comiin, ajanvarauskumppanisi luo. Säästä aikaa, lisää täyttöastetta ja anna yhteisösi pysyä aktiivisena ilman vaivannäköä.",
    "home.cta1": "Aloita ilmaiseksi",
    "home.cta2": "Katso live-demo",
    "nav.home": "Etusivu",
    "nav.about": "Tietoa",
    "nav.terms": "Käyttöehdot",
    "nav.privacy": "Yksityisyydensuoja",
    "nav.rightsReserved": "Kaikki oikeudet pidätetään",
    "nav.locale": "Suomi",
    "site.title": "Geimit.com",
    "site.description": "Pidä pallo pelissä",
    "search.title": "Etsi",
    "about.title": "Tietoa",
    "booking.label.confirmDetails": "Vahvista omat tietosi ja varaa",
    "booking.toast.bookedSuccessfully": "Varaus onnistui!",
    "booking.toast.bookingFailed": "Virhe varauksen kanssa.",
    "booking.label.name": "Nimi",
    "booking.placeholder.name": "Matti Meikäläinen",
    "booking.label.email": "Sähköposti",
    "booking.placeholder.email": "matti.meikalainen@email.fi",
    "booking.description.acceptTerms":
      "Vahvistamalla tietosi hyväksyt käyttöehtomme.",
    "booking.actions.cancel": "Peruuta",
    "booking.actions.confirmAndBook": "Vahvista ja varaa",
    "booking.helpers.orUse": "Tai varaa käyttämällä",
    "booking.splash.loading": "Ladataan varauskalenteria",
    "booking.label.selectSlot": "Valitse varattava aika",
    "auth.dialog.title": "Luo tili tai kirjaudu sisään",
    "auth.dialog.description":
      "Syötä sähköpostiosoiteesi kirjautuaksesi sisään.",
    "auth.dialog.orUsing": "Tai käyttämällä",
    "auth.login.title": "Tervetuloa",
    "auth.login.description":
      "Syötä sähköpostiosoiteesi kirjautuaksesi sisään.",
    "auth.login.helpers.noPassword": "Ei muistettavia salasanoja",
    "auth.login.helpers.codeToEmail":
      "Lähetämme kirjautumiskoodin sähköpostiisi",
    "auth.login.helpers.email": "Sähköposti",
    "auth.login.helpers.noAccount": "Ei vielä käyttäjää?",
    "auth.login.helpers.orUse": "Tai kirjaudu käyttämällä",
    "auth.login.error.unconfirmed":
      "Odottele hetki! Tilisi täytyy vahvistaa ylläpitäjien toimesta.",
    "auth.login.error.unknown":
      "Kirjautuminen epäonnistui, yritä uudelleen. Mikäli virhe ei ratkea, otathan yhteyttä ylläpitäjiin.",
    "auth.login.action": "Kirjaudu sähköpostilla",
    "auth.login.placeholder": "nimi@esimerkki.com",
    "auth.code.title": "Vahvista kirjautuminen",
    "auth.code.description": "Syötä kuusinumeroinen kirjautumiskoodi.",
    "auth.code.helpers.codeLocation":
      "Kirjautumiskoodin löydät sähköpostistasi",
    "auth.code.helpers.trash": "Tarkista myös roskaposti",
    "auth.code.helpers.code": "Kirjautumiskoodi",
    "auth.code.helpers.noCode": "Etkö saanut kirjautumiskoodia?",
    "auth.code.helpers.sendNewCode": "Lähetä uusi koodi.",
    "auth.code.error.invalidCode":
      "Voi ei. Antamasi kirjautumiskoodi on virheellinen, yritä uudelleen.",
    "auth.code.error.unknown":
      "Kirjautuminen epäonnistui, yritä uudelleen. Mikäli virhe ei ratkea, otathan yhteyttä ylläpitäjiin.",
    "auth.code.newCodeSent":
      "Uusi kirjautumiskoodi lähetettiin sähköpostiisi. Tarkistathan myös roskapostin.",
    "auth.code.action": "Kirjaudu sisään",
    "auth.code.placeholder": "Kirjautumiskoodi",
    "auth.register.title": "Rekisteröidy",
    "auth.register.description":
      "Syötä nimesi sekä sähköpostiosoitteesi rekisteröityäksesi.",
    "auth.register.helpers.noPasswords":
      "Vaivaton rekisteröityminen ilman salasanoja",
    "auth.register.helpers.confirmationEmail":
      "Vahvistuskoodi lähetetään sähköpostiisi",
    "auth.register.helpers.alreadyRegistered": "Onko sinulla jo tili?",
    "auth.register.helpers.email": "Sähköposti",
    "auth.register.helpers.name": "Nimi",
    "auth.register.helpers.orUse": "Tai rekisteröidy käyttämällä",
    "auth.register.error.noAccount":
      "Annetulle sähköpostille ei löytynyt käyttäjää. Sinun tulee ensin rekisteröityä.",
    "auth.register.error.unknown":
      "Rekisteröityminen epäonnistui, yritä uudelleen. Mikäli virhe ei ratkea, otathan yhteyttä ylläpitäjiin.",
    "auth.register.accountCreated":
      "Käyttäjän luonti onnistui! Syötä sähköpostistasi löytyvä koodi kirjautuaksesi sisään. Tarkistathan myös roskapostin.",
    "auth.register.action": "Rekisteröidy",
    "auth.register.emailPlaceholder": "nimi@esimerkki.com",
    "auth.register.namePlaceholder": "Matti Meikäläinen",

    "auth.label.loggingIn": "Kirjataan sisään.",
  },
  en: {
    "home.title": "Start unlocking your business's full potential today",
    "home.description":
      "Say hello to Geimit.com, your appointment partner. Save time, increase bookings, and let your community stay active without the hassle.",
    "home.cta1": "Start for free",
    "home.cta2": "View live demo",
    "nav.home": "Home",
    "nav.about": "About",
    "nav.terms": "Terms",
    "nav.privacy": "Privacy",
    "nav.rightsReserved": "All rights reserved",
    "nav.locale": "English",
    "site.title": "Geimit.com",
    "site.description": "Keep the ball in play",
    "search.title": "Search",
    "about.title": "About",
    "booking.label.confirmDetails": "Confirm your details and book",
    "booking.toast.bookedSuccessfully": "Booking successful!",
    "booking.toast.bookingFailed": "Error with the booking.",
    "booking.label.name": "Name",
    "booking.placeholder.name": "John Doe",
    "booking.label.email": "Email",
    "booking.placeholder.email": "john.doe@email.com",
    "booking.description.acceptTerms":
      "By confirming your information, you accept our terms of use.",
    "booking.actions.cancel": "Cancel",
    "booking.helpers.orUse": "Or book using",
    "booking.actions.confirmAndBook": "Confirm and book",
    "booking.splash.loading": "Loading booking calendar...",
    "booking.label.selectSlot": "Select a time slot to book",
    "auth.dialog.title": "Create an account or log in",
    "auth.dialog.description": "Enter your email address to log in.",
    "auth.dialog.orUsing": "Or using",
    "auth.login.title": "Welcome",
    "auth.login.description": "Enter your email address to log in.",
    "auth.login.helpers.noPassword": "No passwords to remember",
    "auth.login.helpers.codeToEmail": "We'll send a login code to your email",
    "auth.login.helpers.email": "Email",
    "auth.login.helpers.noAccount": "Don't have an account?",
    "auth.login.helpers.orUse": "Or login using",
    "auth.login.error.unconfirmed":
      "Hang tight! Your account needs to be confirmed by the administrators.",
    "auth.login.error.unknown":
      "Login failed, please try again. If the issue persists, please contact the administrators.",
    "auth.login.action": "Log in with email",
    "auth.login.placeholder": "name@example.com",
    "auth.code.title": "Confirm Login",
    "auth.code.description": "Enter a six-digit login code.",
    "auth.code.helpers.codeLocation":
      "You'll find the login code in your email",
    "auth.code.helpers.trash": "Also check your spam folder",
    "auth.code.helpers.code": "Login code",
    "auth.code.helpers.noCode": "Didn't receive the login code?",
    "auth.code.helpers.sendNewCode": "Send a new code.",
    "auth.code.error.invalidCode":
      "Oh no. The login code you entered is invalid. Please try again.",
    "auth.code.error.unknown":
      "Login failed, please try again. If the issue persists, please contact the administrators.",
    "auth.code.newCodeSent":
      "A new login code has been sent to your email. Please also check your spam folder.",
    "auth.code.action": "Log in",
    "auth.code.placeholder": "Login code",

    "auth.register.title": "Sign up",
    "auth.register.description":
      "Enter your name and email address to register.",
    "auth.register.helpers.noPasswords":
      "Effortless sign-up, no passwords needed",
    "auth.register.helpers.confirmationEmail":
      "Confirmation code will be sent by email",
    "auth.register.helpers.alreadyRegistered": "Already have an account?",
    "auth.register.helpers.email": "Email",
    "auth.register.helpers.name": "Name",
    "auth.register.helpers.orUse": "Or register using",
    "auth.register.error.noAccount":
      "No user found for the provided email. You need to register first.",
    "auth.register.error.unknown":
      "Registration failed, please try again. If the issue persists, please contact the administrators.",
    "auth.register.accountCreated":
      "User created successfully! Enter the code found in your email to log in. Please also check your spam folder.",
    "auth.register.action": "Register",
    "auth.register.emailPlaceholder": "name@example.com",
    "auth.register.namePlaceholder": "John Doe",

    "auth.label.loggingIn": "Logging you in.",
  },
} as const;
